const LOAD_AUTH = "LOAD_AUTH"
const LOADED_AUTH = "LOADED_AUTH"
const LOADING_AUTH_FAILED = "LOADING_AUTH_FAILED"
const LOADING_AUTH_ERROR = "LOADING_AUTH_ERROR"

export { LOAD_AUTH, LOADED_AUTH, LOADING_AUTH_ERROR, LOADING_AUTH_FAILED }
